// RFC 7636 helpers – public client, no secret needed
export function base64Url(str: string) {
  return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function randomString(len = 32) {
  const array = new Uint8Array(len);
  crypto.getRandomValues(array);
  return String.fromCharCode(...array);
}

export function generateVerifier() {
  return base64Url(randomString());
}

export async function generateChallenge(verifier: string) {
  const digest = await crypto.subtle.digest('SHA-256',
    new TextEncoder().encode(verifier));
  return base64Url(String.fromCharCode(...new Uint8Array(digest)));
}
